import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Table, Button, Alert, Pagination, Spinner } from 'react-bootstrap';
import api from '../utils/api';

class ReceiptsForMember extends Component {
    constructor(props) {
        super(props);
        const { searchCriteria, currentPage: memberSearchPage } = props.location.state || {};
        this.state = {
            receipts: [],
            memberName: "",
            error: null,
            currentPage: 1,
            receiptsPerPage: 10,
            totalReceipts: 0,
            selectedReceipt: null,
            searchCriteria: searchCriteria || {},
            memberSearchPage: memberSearchPage || 1,
            loading: false,
        };
    }

    componentDidMount() {
        // Fetch receipts based on current state or URL parameter
        const { location } = this.props;
        const queryParams = new URLSearchParams(location.search);
        const pageNumber = parseInt(queryParams.get('pagerfm')) || 1;

        this.setState({ currentPage: pageNumber }, () => {
            this.getReceipts();
        });
    }

    formatDate = (dateStr) => {
        // Check if dateStr is undefined, null, or an empty string
        if (!dateStr) {
            return ''; // Return an empty string or any default value if dateStr is not valid
        }
    
        // Split the date string into its components
        const [year, month, day] = dateStr.split('-');
        
        // Return the formatted date as MM/DD/YYYY
        return `${month}/${day}/${year}`;
    };

    handleBack = () => {
        const { searchCriteria, memberSearchPage } = this.state;
        this.props.history.push({
            pathname: '/members',
            state: { searchCriteria, currentPage: memberSearchPage }
        });
    };

    handleRowClick = (receipt) => {
        this.setState({ selectedReceipt: receipt });
    }

    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber }, this.getReceipts);
    }

    getReceipts() {
        this.setState({ loading: true });
        const { memberId } = this.props.match.params;
        const { currentPage, receiptsPerPage } = this.state;
        const path = `/api/members/${memberId}/receipts?page=${currentPage}&limit=${receiptsPerPage}`;

        api.get(path)
            .then(res => {
                if (res.data && Array.isArray(res.data.data) && res.data.data.length > 0) {
                    const memberName = `${res.data.data[0].first1} ${res.data.data[0].middle1} ${res.data.data[0].last1}`;
                    this.setState({
                        receipts: res.data.data,
                        memberName,
                        totalReceipts: res.data.total,
                        loading: false,
                    });
                } else {
                    this.setState({ receipts: [], memberName: "", totalReceipts: 0, loading: false });
                }
            })
            .catch(() => {
                this.setState({ error: 'Failed to fetch receipts. Please try again later.', loading: false });
            });
    }

    renderPagination() {
        const { currentPage, receiptsPerPage, totalReceipts } = this.state;
        const totalPages = Math.ceil(totalReceipts / receiptsPerPage);

        if (totalPages === 1) return null;

        return (
            <Pagination>
                <Pagination.First onClick={() => this.handlePageChange(1)} disabled={currentPage === 1} />
                <Pagination.Prev onClick={() => this.handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                {[...Array(totalPages)].map((_, index) => (
                    <Pagination.Item
                        key={index + 1}
                        active={index + 1 === currentPage}
                        onClick={() => this.handlePageChange(index + 1)}
                    >
                        {index + 1}
                    </Pagination.Item>
                ))}
                <Pagination.Next onClick={() => this.handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                <Pagination.Last onClick={() => this.handlePageChange(totalPages)} disabled={currentPage === totalPages} />
            </Pagination>
        );
    }

    renderDonationRows() {
        const { receipts, selectedReceipt, searchCriteria, memberSearchPage, currentPage } = this.state;

        return receipts.map(receipt => (
            <tr
                key={receipt.receiptNum}
                className={receipt === selectedReceipt ? 'selected-row' : ''}
                onClick={() => this.handleRowClick(receipt)}
            >
                <td className="align-middle">
                    <Link
                        to={{
                            pathname: `/receiptDetails/${receipt.receiptNum}`,
                            search: `?pagerfm=${currentPage}`,
                            state: { searchCriteria, currentPage: memberSearchPage }
                        }}
                        className="receipt-link"
                    >
                        {receipt.receiptNum}
                    </Link>
                </td>
                <td className="align-middle">{this.formatDate(receipt.receiptDate)}</td>
                <td className="align-middle">{receipt.memberId}</td>
                <td className="align-middle">
                    {receipt.modeOfPayment === 1 ? "CASH" : (receipt.modeOfPayment === 2 ? "CHECK" : "CREDIT CARD")}
                </td>
                <td className="align-middle">
                    {receipt.paymentReference || "---"}
                </td>
                <td className="align-middle">{receipt.city}</td>
                <td className="align-middle">${receipt.donationAmt}</td>
            </tr>
        ));
    }

    render() {
        const { receipts, memberName, error, totalReceipts, loading } = this.state;

        return (
            <div className="container">
                {error && <Alert variant="danger">{error}</Alert>}
                {loading ? (
                    <div className="text-center">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    receipts.length > 0 ? (
                        <div>
                            <span>List of Donations for {memberName}</span>
                            <Button className="btn btn-secondary float-right" onClick={this.handleBack}>Go Back</Button>
                            <Table striped bordered hover size="sm" className="donation-table">
                                <thead>
                                    <tr>
                                        <th>Receipt Num</th>
                                        <th>Receipt Date</th>
                                        <th>Member ID</th>
                                        <th>Payment Mode</th>
                                        <th>Reference Number</th>
                                        <th>City</th>
                                        <th>Donation Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderDonationRows()}
                                </tbody>
                            </Table>
                            {totalReceipts > 10 && this.renderPagination()}
                        </div>
                    ) : (
                        <div className="text-center">
                            <div>No donation receipts were found for this member</div>
                            <Button className="btn btn-secondary" onClick={this.handleBack}>Go Back</Button>
                        </div>
                    )
                )}
            </div>
        );
    }
}

export default withRouter(ReceiptsForMember);